import { JDImage, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';
import React from 'react';
import {
    Text,
    View,
    StyleSheet,
    TouchableOpacity
} from 'react-native';
import { pt } from '../../../../components/utiles';
// import PropTypes from 'prop-types';

const img = {
    unSelected: 'https://img13.360buyimg.com/imagetools/jfs/t1/93331/10/25468/2391/63148b18E36c81f65/f97969eeafa6cdc0.png',
    selected: 'https://img10.360buyimg.com/imagetools/jfs/t1/31629/21/17417/3431/63148b18E5533d1ae/afc7fa11d7c52051.png'
};

const CityItem = (props) => {
    return (
        <JDTouchableWithoutFeedback onPress={props.onSelect}>
            <View style={styles.cityItem}>
                <Text style={props.isSelected ? styles.cityItemTitleSelected : styles.cityItemTitle}>{props.title}{props.unitStr?props.unitStr:''}</Text>
                {props.isMultiSelect && <JDImage source={props.isSelected ? { uri: img.selected } : { uri: img.unSelected }} style={styles.selectIcon} />}
            </View>
        </JDTouchableWithoutFeedback>
    );
};

export default CityItem;

const styles = StyleSheet.create({
    cityItem: {
        width: '100%',
        height: pt(88),
        backgroundColor: '#fff',
        flexDirection: 'row',
        alignItems: 'center',
        // justifyContent: 'flex-start',
        justifyContent: 'space-between',
        paddingLeft: pt(30),
        paddingRight: pt(30)
    },
    cityItemTitle: {
        fontSize: pt(26),
        color: '#262626',
        flex: 1
        // paddingRight: 10,
        // flex: 1
    },
    cityItemTitleSelected: {
        color: '#FA2C19',
        flex: 1,
        fontSize: pt(26),
    },
    selectIcon: {
        width: pt(30),
        height: pt(30)
        // marginLeft: 10
    }
});
